import React from 'react';
import { Link } from 'react-router-dom';
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { orderBy } from "@progress/kendo-data-query";
import HfKendoComboBox from "../shared/HfKendoComboBox";
import Api from '../../services/api/api';

export default class SearchForm extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedPatient: null,
            estimateId: null,
            selectedUser: null,
            estimates: [],
            sort: [
                {
                    field: "id",
                    dir: "desc",
                },
            ],
        };

        this.handlePatientChange = this.handlePatientChange.bind(this);
        this.handleEstimateIdChange = this.handleEstimateIdChange.bind(this);
        this.handleUserChange = this.handleUserChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
    }

    componentDidMount() {
    }

    handlePatientChange = (e) => {
        this.setState({
            selectedPatient: e.value,
            estimateId: null,
            selectedUser: null
        });

    }

    handleEstimateIdChange = (e) => {
        this.setState({
            selectedPatient: null,
            estimateId: e.value,
            selectedUser: null
        });
    }

    handleUserChange = (e) => {
        this.setState({
            selectedPatient: null,
            estimateId: null,
            selectedUser: e.value
        });
    }

    handleSearch = () => {
        let searchCall;
        let searchTerm;

        if (this.state.selectedPatient) {
            searchCall = Api.searchSummariesByPatient;
            searchTerm = this.state.selectedPatient.patientId;
        } else if (this.state.estimateId) {
            searchCall = Api.searchSummariesById;
            searchTerm = this.state.estimateId;
        } else if (this.state.selectedUser) {
            searchCall = Api.searchSummariesByUser;
            searchTerm = this.state.selectedUser.userId;
        }

        searchCall(searchTerm).then((result) => {
            // Single results are returned as an object. When that happens, convert to an array
            if (!Array.isArray(result)) {
                result = [result];
            }

            result.forEach(x => {
                x.estimateDate = new Date(x.estimateDate);
            });

            this.setState({ estimates: result });
        });
    }

    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-sm-12 col-md-6">
                        <h1 className="page-header">Estimate Search</h1>
                    </div>
                </div>
                <div className="row">
                    <div className="card shadow">
                        <div className="card-body">
                            <h5 className="card-title">Criteria</h5>
                            <div className="panel-body">
                                <div className="row form-group">
                                    <label className="control-label col-sm-2">Patient Name</label>
                                    <div className="col-sm-4">
                                        <HfKendoComboBox
                                            delay={500}
                                            minLengthForSearch={4}
                                            api={Api.searchPatients}
                                            dataItemKey="patientId"
                                            textField="displayName"
                                            value={this.state.selectedPatient}
                                            onChange={this.handlePatientChange}
                                            placeholder="Search by Name or Patient/Enterprise ID..."
                                            style={{ width: "100%" }}
                                        />
                                    </div>
                                </div>
                                <div className="row form-group">
                                    <label className="control-label col-sm-2">Estimate ID</label>
                                    <div className="col-sm-4">
                                        <NumericTextBox
                                            spinners={false}
                                            min={0}
                                            maxLength={8}
                                            format="#"
                                            value={this.state.estimateId}
                                            onChange={this.handleEstimateIdChange}
                                        />
                                    </div>
                                </div>
                                <div className="row form-group">
                                    <label className="control-label col-sm-2">User</label>
                                    <div className="col-sm-4">
                                        <HfKendoComboBox
                                            delay={500}
                                            minLengthForSearch={1}
                                            api={Api.searchUsers}
                                            dataItemKey="uid"
                                            textField="displayName"
                                            value={this.state.selectedUser}
                                            onChange={this.handleUserChange}
                                            placeholder="Search by Name or Username..."
                                            style={{ width: "100%" }}
                                        />
                                    </div>
                                </div>
                                <div className="row form-group print-hidden">
                                    <label className="control-label col-sm-2"></label>
                                    <div className="col-sm-10 btn-toolbar">
                                        <button type="button" className="btn btn-primary" onClick={this.handleSearch}>Search</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="card shadow">
                        <div className="card-body">
                            <h5 className="card-title">Results</h5>
                            {/*<BootstrapTable data={this.state.estimates} striped={true} hover={true}>*/}
                            {/*    <TableHeaderColumn dataField="id" dataSort={false} dataAlign="center" dataFormat={id => <a href={`/Worksheet/Edit/${id}`}>View</a>}></TableHeaderColumn>*/}
                            {/*    <TableHeaderColumn dataField="id" isKey={true} dataSort={true} dataAlign="center">Estimate ID</TableHeaderColumn>*/}
                            {/*    <TableHeaderColumn dataField="estimateDate" dataSort={true} dataFormat={date => date.toLocaleDateString()}>Estimate Date</TableHeaderColumn>*/}
                            {/*    <TableHeaderColumn dataField="selectedPatient" dataSort={true} dataFormat={p => p.Name}>Patient Name</TableHeaderColumn>*/}
                            {/*    <TableHeaderColumn dataField="selectedPatient" dataSort={true} dataFormat={p => p.PatientId}>Patient ID</TableHeaderColumn>*/}
                            {/*    <TableHeaderColumn dataField="createdBy" dataSort={true}>Prepared By</TableHeaderColumn>*/}
                            {/*    <TableHeaderColumn dataField="amountDue" dataSort={true} dataFormat={value => formatNumber(value, '$0.00')}>Amount</TableHeaderColumn>*/}
                            {/*</BootstrapTable>*/}
                            <Grid
                                data={orderBy(this.state.estimates, this.state.sort)}
                                sortable={true}
                                sort={this.state.sort}
                                onSortChange={(e) => {                                    
                                    this.setState({
                                        sort: e.sort,
                                    });
                                }}
                            >
                                <GridColumn sortable={false} cell={(props) => (<td><Link to={`/Worksheet/${props.dataItem.id}`}>View</Link></td>)} />
                                <GridColumn field="id" sortable={true} title="Estimate ID" />
                                <GridColumn field="estimateDate" sortable={true} filter="date" format="{0:MM/dd/yyyy}" title="Estimate Date" />
                                <GridColumn field="selectedPatient.Name" sortable={true} title="Patient Name" />
                                <GridColumn field="selectedPatient.PatientId" sortable={true} title="Patient ID" />
                                <GridColumn field="createdBy" sortable={true} title="Prepared By" />
                                <GridColumn field="amountDue" sortable={true} filter="numeric" format="{0:$0.00}" title="Amount" />
                            </Grid>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}